var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C9.791 15 8 13.209 8 11V6C8 3.791 9.791 2 12 2C14.209 2 16 3.791 16 6V11C16 13.209 14.209 15 12 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.0568 13.0159C18.3888 12.8249 17.6568 13.1079 17.3408 13.7269C16.3478 15.6689 14.3308 16.9999 11.9998 16.9999C9.66879 16.9999 7.65179 15.6689 6.65979 13.7269C6.34379 13.1079 5.61179 12.8249 4.94379 13.0159C4.03279 13.2759 3.58379 14.3109 4.02179 15.1509C5.22279 17.4589 7.39979 19.1609 10.0008 19.7549V19.9999C10.0008 21.1049 10.8958 21.9999 12.0008 21.9999C13.1058 21.9999 14.0008 21.1049 14.0008 19.9999V19.7549C16.6018 19.1609 18.7788 17.4589 19.9798 15.1509C20.4168 14.3109 19.9678 13.2759 19.0568 13.0159Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 22.0002C20.7442 22.0002 20.4882 21.9023 20.2932 21.7073L2.29325 3.70725C1.90225 3.31625 1.90225 2.68425 2.29325 2.29325C2.68425 1.90225 3.31625 1.90225 3.70725 2.29325L21.7073 20.2932C22.0983 20.6842 22.0983 21.3162 21.7073 21.7073C21.5123 21.9023 21.2563 22.0002 21.0002 22.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteLightIcon);
export default __webpack_public_path__ + "static/media/mute-light-icon.fd25b898a81b9d6bf512055e30c9d531.svg";
export { ForwardRef as ReactComponent };